import { render } from "./InvoiceItemField.vue?vue&type=template&id=1f396b14&ts=true"
import script from "./InvoiceItemField.vue?vue&type=script&lang=ts"
export * from "./InvoiceItemField.vue?vue&type=script&lang=ts"

import "./InvoiceItemField.vue?vue&type=style&index=0&id=1f396b14&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__